<template>
  <div class="sellerScene">
    <div ref="pixiContainer" class="pixi-container" />
  </div>
</template>

<script setup lang="ts">
import { Application, Assets, Sprite } from 'pixi.js';

const isSellerOpen = inject<Ref<boolean>>('sellerIsOpen');
const pixiContainer = ref<HTMLElement | null>(null);
const currentApp = shallowRef<Application | null>(null);

const initVideo = async (el: HTMLElement) => {
  try {
    if (currentApp.value) {
      return;
    }

    if (!isSellerOpen) {
      return;
    }

    const videoName = isSellerOpen.value ? 'seller' : 'seller_closed';
    const texture = Assets.get(videoName);
    const videoElement = texture.baseTexture.resource.source;
    videoElement.muted = true;
    videoElement.loop = true;
    videoElement.playsInline = true;

    const app = new Application({
      width: isSellerOpen.value ? 220 : 250,
      height: 333,
      antialias: true,
      background: '#081b25'
    });

    currentApp.value = app;

    const videoSprite = new Sprite(texture);
    videoSprite.width = app.renderer.width;
    videoSprite.height = app.renderer.height;

    app.stage.addChild(videoSprite);
    await videoElement.play();

    el.appendChild(app.view as unknown as HTMLCanvasElement);

    app.ticker.add(() => {
      if (texture.baseTexture.resource) {
        texture.baseTexture.resource.update();
      }
    });
  } catch (error) {
    console.error('Error initializing video:', error);
  }
};

watch(pixiContainer, async (el) => {
  if (!el) {
    return;
  }
  await initVideo(el);
});

watch(
  () => isSellerOpen?.value,
  async () => {
    if (!pixiContainer.value) {
      return;
    }

    if (currentApp.value) {
      currentApp?.value.destroy(true, { children: true, texture: true, baseTexture: true });
      currentApp.value = null;
    }
    await initVideo(pixiContainer.value);
  }
);
</script>

<style lang="scss">
.sellerScene {
  .pixi-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .pixi-container canvas {
    max-width: 100%;
    height: auto;
  }
}
</style>
